import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  content: {
    paddingRight: theme.spacing[5],
    paddingLeft: theme.spacing[5],
    backgroundColor: colors.backgroundL0,
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing[8],
  },
  titleContainer: {
    flex: 1,
  },
  calendarOptions: {
    flexDirection: 'row',
    gap: theme.spacing[4],
    marginBottom: theme.spacing[6],
  },
  calendarOption: {
    flex: 1,
    alignItems: 'center',
    gap: theme.spacing[6],
    // paddingVertical: theme.spacing[4],
    // paddingHorizontal: theme.spacing[3],
  },
  calendarIconContainer: {
    // padding: theme.spacing[2],
    // backgroundColor: colors.backgroundSecondary,
    borderRadius: theme.borderRadius.full,
  },
  calendarIcon: {
    // marginBottom: theme.spacing[2],
    borderRadius: theme.borderRadius.full,
  },
  calendarLabel: {
    textAlign: 'center',
  },
}));
